import {
  ReactNode,
  Fragment,
  ComponentType,
  ReactElement,
  PropsWithChildren,
} from 'react';

import AkSpinner from '@atlaskit/spinner';

import {
  ConnectModules,
  ConnectModulesRequestProps,
  ConnectModulesStandardProps,
} from '../../internal/modules';
import Connect, { ConnectProps } from '../../main/connect';

import WebItem from './webItem';

export interface ConnectWebItemBaseProps {
  children?: (items: Array<ReactElement<any>>) => ReactNode;
  component?: ComponentType<PropsWithChildren<any>>;
  loadingComponent?: ComponentType<PropsWithChildren<any>>;
  loadingFailedComponent?: ComponentType<PropsWithChildren<any>>;
}

export type ConnectWebItemProps = ConnectWebItemBaseProps &
  ConnectModulesRequestProps &
  ConnectModulesStandardProps &
  ConnectProps;

const WebItemLoader = () => <AkSpinner size="small" />;
const WebItemLoaderFailed = () => null;

// eslint-disable-next-line import/no-default-export
export default Connect(
  ({
    children,
    loadingComponent: Loading = WebItemLoader,
    loadingFailedComponent: LoadingFailed = WebItemLoaderFailed,
    ...props
  }: ConnectWebItemProps) => {
    return (
      <ConnectModules {...props} moduleType="webItems">
        {({ modules, loading, error }) => {
          if (error) {
            return (
              <LoadingFailed
                {...props}
                loadingFailedComponent={WebItemLoaderFailed}
              />
            );
          }
          if (loading) {
            return <Loading {...props} loadingComponent={WebItemLoader} />;
          }

          const filteredModules = modules.filter(
            m =>
              m.app_key !== 'bitbucket-prlinks' &&
              m.app_key !== 'prlinks-installer'
          );

          const items = filteredModules.map(m => (
            <WebItem {...props} module={m} key={m.id} />
          ));
          return typeof children === 'function' ? (
            children(items)
          ) : items.length ? (
            <Fragment>{items}</Fragment>
          ) : (
            false
          );
        }}
      </ConnectModules>
    );
  }
);
